// eslint-disable-next-line import/prefer-default-export
export const REASON_OPTIONS = [
  { label: 'Price', value: 'price' },
  { label: 'Responsiveness', value: 'responsive' },
  { label: 'Profile', value: 'profile' },
  { label: 'Prior Work', value: 'prior_work' },
  { label: 'Professionalism', value: 'professional' },
  { label: 'Other', value: 'other' },
];
